import React, { useEffect, useState } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

const snail =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAApgAAAKYB3X3/OAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAN3SURBVEiJtZZPTFxVFIe/c9+bN28YmFpALBBKsYa0llCwRBttTONCTYzupImKpjFxZW1ijLpxoyZGN+LCnS5oDTFqoqsmruyiqaWJ0mgXlprSNlAoFYeBgfnz3rvHxTAzTmCa2MpZ3dx7z+8795z7zn2iqmylmS1V/98Av+3s40LX4S0BhCcHDmnWOY3K9wD82NfML93TTHa9C+DejXjuxECna+RjCdxnSYZRfvyhbkfdr91tkhVPbt41wHUZxg+uY/GYmjnj2NYvFT6Vg1e/Ke+RO7lFwaneRyTv/SANQZvZXjDiRQA5zXqrotHDPH51ui7g2+Fhp6fd3xtBn1j6QAOFi47DxaHPvpqyp/a+HWViH7mdWZHG4mb8RcQ+x8Ds2Q2Ac8dGDovwOfDgZp5+Kje5b9/l/aY1Z0xrrv4RhSuYoJ/++dXSLRKRc8dHvhDhp7K4qhIWioTFgHIQPXuuDWLUmJbbiAMo9xN5b8J6kSdef/EdUV4FCApFsukMQb5Q4xNvSOC7AZIMQarzUzcS9HZUgdYKf8779LbnDgGYiTdeOojIhwD57BrpuYUN4gBBPodEIPGwKqZw5aZPEAnvjXfz3c+tBJEwveCDMLh+AnME1ImCkJXFNABuLIbf1ICX8EGhsJYjLK6ACphqzYzA04Mlnw9euFaZf2ogDZACcBV9TCiJqCoIpNqacWOxioPrxbChA6Rvn/tay5aD6AUIgwCAmOfViJctnvRKA9mwVMdksgy4UBaGUpGLm9SgqXm+5OaXaqAFB7sUrytvizINYFT1bCnCBMYp3drMwiLLf/1NYS1HPrtG5tYiqe1LYLQCkHiErsWwaX9zwHzjkWB8cMA4jowBq8ZxSN3bghhBrS0Jl0GrOVLbLNIQghWiG42g4HRkscse2Nq82UwcXfFSWDlhhkZPXhLV1wA8P05L5w4STUkc16k4HHhyGVcEpyMLjiLJgGimCc25gIDUtJu5aCE5tj5eqrSKieMjb6G8DyTKO9UqHQ/M0d62iLsrgySq34DmXOyKh0kVK2kDzmPtKxyY/aMwNrQ7XuB6TS86f+zlHhUdBZ4BHID9j/6OGw9xd2XqFhRYQHSUy7Of8LxG/17YtF2fPnrUT95T3GND6Wvffavrvp1zT8R2rJwxflClGFFUpnHsr/TPzNQj39F78F9sy/8q/gGTTnTqqcBWPQAAAABJRU5ErkJggg==";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

function getRecipeTagColor(recipeTags, tag) {
  const paths = tag.split("/");

  if (paths.length > 1 && recipeTags.hasOwnProperty(paths[0])) {
    if (recipeTags[paths[0]].children.hasOwnProperty(paths[1])) {
      return recipeTags[paths[0]].children[paths[1]].color;
    } else {
      return recipeTags[paths[0]].color;
    }
  } else if (recipeTags.hasOwnProperty(paths[0])) {
    return recipeTags[paths[0]].color;
  }

  return "#ff0000";
}

function generateSeasons(recipe) {
  if (recipe.seasons) {
    const seasons = [];

    if (recipe.seasons.spring) {
      seasons.push([
        {
          image:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAA7AAAAOwBeShxvQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAQySURBVFiFtZdPbFRVFIe/896bmU5b2jJTJI0tFEorUKioSFgQIjFEggaKUmJjghqiIVrWbsQMdOHGuERbg0GRBXUBNdLEmLigpQtQ00CpWGltCtZQSmlpKf3z5h4XdgpT5nWmA5zVzbnn/n5fzr1z7xthOkoP6bsifI7wVudBaSKFqGrdF/KZwIcjLrvP9EmFY6HZjgzn2tqoeYv292yJjCfTsGIDEQ4AeSinnqnVHckWvtlc85ITDXSocthCKgzCpBEZnCTv73vy9u2bA4Ormg5sTAlgeUSXAM9N5/yqNJTV6nZP85aa9RbmDLDYq2bYJdg7Ys6uaTpQkhTAFl6elQ94daKqocoW1W8UMhMJZg+7WEYBuBsV361xbUwKIBZbEswl7IRTsGg76OqE5ndcdhy9xrMtQzO5/gnK15z+oMgLwAFAWekxH+tE1Z8H5Yfp3DYvsbvZNh0b8uhZmTWTiyr0R6V155fv/fLFtzfPxfIGzhe2nm6LHcIlXqL834nvZ7ZDKfYqVEto27SQoXx/XL5/QgobcwJ7LyzLqEOpQ6mzlCaIdQDCcwDEIBrKavV1pKYYNEn5/QjauCEfV0qH3NF1vVPNomIAsM3ZBwHcB8ZeEQA9PTyw1srNv5iSeVGmaQ7r2I62XceG/gGWJqiJmU4AGUkVVXxd7fsoWVtPbvjynKWFQX67Vnlk87UkkrEzcD2peYxBHbra32d4oMKzxhZYZAJvpKInAGWH9SSwJ1UIALFcSsqPkpt/kaAd4vmcV1mXU8QCO4Oe8RvjO0vKg6noOAAi/K46PwA1Dt3t+9i/rZ3qleWMjU7OzK3IWpz0DYiFBRBVfpyPeSyMOjQ0ryMajT+/C+zM2/MCuPqJXFb4Kx2IgVFovDRLVKZ/aqkCTA+OpAMA0Not6S69DzBiqAcG0hH5907a/vcB+iIyBhxKR8SxHwMAQKfhCHDOo9YzSvNnZ2QoUV1SACJiooZ3gFvzAdi6Kv5tEKE3PQCgKyJXsai0xLipCLy4FDYtj8+J8FPaAAAbt9b8sayi3rWdue+TFU9B7WuzBC1xCxYGvnokAHdKq/NClzJWrf+U0OILWNZU3Hx2APZugKPVEJr1YebY9hmZxz2Q8AlWZBcogeAAy1Yfwxg/YyOFuG4mPv8oH79QRVlO8UPrbMu6Z8KB6lTNIUEHIhqxUN0QV2RNkp3bTV64nawFPZy8foIpE98VS8T4fNbuIpF7jwTQ2XKjGMiea1HfWB/He74jqlEAFPp9AaeqIJSR0h+aB+OhLTBih0STb+GFwV+5PTlE9ZI9rUX+pyvDCwM352ueEEBMNAtJerd3Az93jXR+vTpceD4dY0+AWdGH6kdGrPM2xjVGpnzjmYPHX/ns7qOYpgowYWl064nNdR2PyyxRJLwHAARanrR5YgC//4ogvQY99aTNAf4DW81vHAZ2EaYAAAAASUVORK5CYII=",
          width: 24,
        },
      ]);
    }

    if (recipe.seasons.summer) {
      seasons.push([
        {
          image:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAuQAAALkB4qdB6AAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAALGSURBVEiJnZVPSFRxEMc/89T6iWV/sNWKjEAxlIKiQ51UyA0p1pKsQKpbhw6S1UE0OphIIF2KLp3EwIjKSArRLgpdCiEq3ZI1osD8gyGYsU9t33RYFd/uc9Od43dmPjPze7/5PViD6UBFrQ5U1K4lx/IEhcozdaDiWJxDyELIiov/dNKvofLMVRdgPj0D4bEGT+S7SWKjYrukwUAelj5mPj1j1QWksGMU0buo1eRy2L7b2L7bMdFNiN6Two5RT5bnBIB+KzHYWw7w6/kAEVMF+MHZFXVaP4Ae1H5Czql9mKn3sqfX9uJIdMyqraTMGtnb+dNVpM9cBG0Btq3QxwQq16XEfujKC1Zu5++sLftfTUWPSGaPEJGgBgONGipfD6C9phm0NQEcwIdom/aZW4tTazDQiEY+k5J22HVEOhjIA6sZ9A6T3XsX4Ks3lQv4ykKo1AINUtQ57CqwFPeGjUTWf/1P5142jjObJ6XMLBfjb1HEnEkCDpBNijkdK3pd07Ik4IvmjxVSdTBwFREfqmHCOc38ad2d4PYmNnV2a/+lNNLH6hFJR3XCawJNjg4gcbnxH7nXPEL0XJIF2qXYrl6ueE3QkxwcgO5YIb5Aqv0UGE8CPoZjd8SK8YtmyX3Gu3IRbVsbX6vxHR/BiVxm2aJZANG3X/oR5wtm6m30bZGmhDxXm9IoxXPtbEh9hzAE0q/BiqNLE+gHfwZm3WYpeDni6qnXnEe0BcheAT0Gek2K59pdeUMndmJFfkt+13Ti53pm00EmX3xc2FA/qrkLLX8HenDsZ/97rlNXHDucWY+lBVLKWbBbgVbtv5QGIIcezC81Mhi5QjhzCLjphfH+J38J7EClBnFuuBxmog4zURcT3oBKjQYrt6+6ACnzMzhyRgpfhly6qEHUuKSizmFEq0gL//FCeR6R5HdN47VwyqRnfGHna89GgX9V7A2tBAHQBAAAAABJRU5ErkJggg==",
          width: 24,
        },
      ]);
    }

    if (recipe.seasons.autumn) {
      seasons.push([
        {
          image:
            "data:image/png;base64,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",
          width: 24,
        },
      ]);
    }

    if (recipe.seasons.winter) {
      seasons.push([
        {
          image:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAsQAAALEBxi1JjQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAARMSURBVEiJlZZPaJRXFMV/5/vejM1Mg1ZDEYx/iAGlpbioNm5cpKXVIrroxIBULN3oIthMalsNImQj2j80iSKohaJFKiQzUkKstYWm4KKtupIKCknqnwhSohXTzCSZ9323C5NgajDNXb133zn3vPMuj/dgFpHN+a3ZnN86G46bDRhsx/jgzP9laCZAw1lbkIiiDfP+CfMPy/15gHlD7u2Hz0cZWXi+tV4PnsUPZhJIWLQW2emH5aXrQDVQ/bC8dB3ZaVNUMxN/WoEPOktvNHXYIoC2jDuHUStpEKgEKiUNYtS2bXHnAZo6bFH2bOn1ZwrszttSzAQQBnSafMPEmiu6ywORq0FcQlwaiFyNK7rLE+sm3yAj93hi+vA7WzxFoLHDlkTm/8zm/cWm3Njq2ChTQNDSYw7Ap/2eRYG/CVQBVYsCf9On/R6Alh5zCghio6wpN7Y6m/cXY+9vTZzAZJMbO/12ZJ8KXhwXPiDTZZM1F+67damK6C0sPgqAgobCYPhjaoG/KNNBk60B9gGxwV8B2tta505NOaL2Le4bZJuB4kQrYtleZL0ndqoUhOFVUAFUCMLw6omdKiHrjWV7gV3jnCKyzRPFpzjIdvp3kX0tMQwcsJj1iDfBbmI6g9gNJMfhoxhfItsKWobxkwIuAPvMSEt6vzXjvp3iQOKRwVEfuRVxFHVLqsboAg0jmouFUvJO/wPu9D+gWCjNQTSDhjG6JFXHUdTtI7fC4Ggc8+gpB0/Gxx22cEz+vfY691ljrrRD0rHb/fcZG4kASD4XsqRqAZLtbH0n8VVjzn+SNHfq83rd+2+tae9BKUSBHosHATYdZkoRoVI4/WYnk005vynGauPYHUy40Rcsdj8Y9odgucFLxUKJwXtDAFQsLKcslQC4htEn6RUFfkPJz/k7CHwzpp/bt7juqQ5EuaDBhf6GWbjJzHqBTYalMA6WpRKji6vms7hqPmWpxCjGQbA0YrOZ9ZqFm1zobwgaJMqfcgDQmB9bI1MPkAaGDK5J1teWSW7blbdKZ/4CgJdbfySjgWx+7LSZlgteBsqBYZPVtmeSk7d80kFjp9+OqQsoG08dDkyHMFXvOG6JkGiVYWnD0iHRqh3HLYGpOjAdAg6Pc8owdTV2+u1TBBo7bIlkJwV9wmoMRiTc3IrwXFtdYm2qwu/H7BhSGimN2bFUhd/fVpdYO7ciPCfhDEaE1Qj6JDu5K2+VkwLt9bptsVvWlnHrWuuSVwJRtJi4pVYeoJB0h+7GbhnQD/Tfjd2yQtIdAmiplbeYOBDF1rrklbaMWxfJLTmS0QA88aK11+v2xNhEnU+66xPz1Ih/LR3yhRmvAlSG/ncb4SPgFwCZOyr8T4+7KjsCA9M2ebrI5v1GzLrBboHC8S1EoKUx2ni4zn3/LP6ML5qi8FdM2+YNJVYCvUDvvKHESkzbwjj8bSb+rCKbK/Vkc6We2XBm+avQidnh4V8CyuJs6Tzi+gAAAABJRU5ErkJggg==",
          width: 24,
        },
      ]);
    }

    return seasons;
  } else {
    return [[{}]];
  }
}

const toDocDefinition = (recipe, recipeTags) => {
  const recipeTagColor = getRecipeTagColor(recipeTags, recipe.tag);
  return {
    pageSize: "A5", // (420 pt x  595 pt)
    // margin: [left, top, right, bottom]
    pageMargins: [0, 0, 0, 0],
    info: {
      title: recipe.title,
      author: "Bearecettes.com",
    },
    content: [
      {
        table: {
          widths: [410],
          heights: ["auto"],
          body: [
            [
              {
                border: [false, false, false, false],
                fillColor: recipeTagColor,
                text:
                  recipe.tag.indexOf("/") < 0
                    ? recipe.tag
                    : recipe.tag.split("/")[1],
                alignment: "right",
              },
            ],
            [
              {
                border: [false, false, false, false],
                fillColor: recipeTagColor,
                text: recipe.title,
                style: "header",
                alignment: "center",
              },
            ],
          ],
        },
      },
      {
        layout: "noBorders",
        table: {
          body: [
            [
              { image: "recipeImage", width: 300, margin: [50, 0, 0, 0] },
              {
                layout: "noBorders",
                margin: [0, 0, 0, 0],
                table: {
                  body: generateSeasons(recipe),
                },
              },
            ],
          ],
        },
      },
      { text: recipe.quote || "", style: "quote" },
      {
        text: recipe.nbPerson ? "Pour " + recipe.nbPerson + " personne(s)" : "",
        alignment: "left",
        margin: [20, 10, 20, 10],
      },
      {
        columns: [
          {
            width: "auto",
            ul: (recipe.ingredients || [])
              .filter((i, j) => j % 2 === 0)
              .map((i) => i.name + ": " + i.quantity + " " + i.unit),
          },
          {
            width: "*",
            ul: (recipe.ingredients || [])
              .filter((i, j) => j % 2 === 1)
              .map((i) => i.name + ": " + i.quantity + " " + i.unit),
          },
        ],
        margin: [20, 10, 20, 20],
      },
      ///////////// STEPS
      {
        pageBreak: "before",
        ol: (recipe.steps || []).map((i) => i),
        alignment: "justify",
        margin: [40, 40, 40, 20],
      },
      { text: recipe.notes || "", style: "notes" },
    ],
    styles: {
      header: {
        fontSize: 30,
        bold: true,
        alignment: "center",
      },
      quote: {
        fontSize: 12,
        color: "green",
        fillColor: "#85b457",
        bold: true,
        alignment: "center",
        margin: [10, 5, 10, 5],
      },
      notes: {
        fontSize: 12,
        color: "#D58739",
        bold: true,
        alignment: "center",
        margin: [10, 5, 10, 5],
      },
    },
    defaultStyle: {
      columnGap: 20,
    },
    images: {
      recipeImage: recipe.url,
    },
  };
};

const RecipePDF = ({ recipe, recipeTags }) => {
  const [dataUrl, setDataUrl] = useState("");

  useEffect(() => {
    if (dataUrl === "") {
      pdfMake.fonts = {
        // Toxic: {
        //   normal: "https://www.bearecettes.com/Toxic.ttf",
        //   bold: "https://www.bearecettes.com/Toxic.ttf",
        //   italics: "https://www.bearecettes.com/Toxic.ttf",
        //   bolditalics: "https://www.bearecettes.com/Toxic.ttf",
        // },

        // download default Roboto font from cdnjs.com
        Roboto: {
          normal:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
          bold: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
          italics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
          bolditalics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf",
        },
      };

      pdfMake
        .createPdf(toDocDefinition(recipe, recipeTags))
        .getDataUrl((durl) => {
          setDataUrl(durl);
        });
    }
  }, [dataUrl]);

  return (
    <embed
      src={dataUrl}
      key={dataUrl} // To force embed refresh
      style={{ width: "100%", height: "calc(100vh - 70px)" }}
      type="application/pdf"
      title={recipe.title + "pdf"}
    />
  );
};

export default RecipePDF;
